import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const AmazonDevice169: FC<Props> = (props) => (
  <Root viewBox="0 0 145.783 300.88" {...props}>
    <defs>
      <clipPath id="amazon1-1_svg__a">
        <path
          data-name="\u9577\u65B9\u5F62 803"
          transform="translate(68.86 283.644)"
          fill="#fff"
          stroke="#707070"
          d="M0 0h108v64H0z"
        />
      </clipPath>
    </defs>
    <g data-name="\u30B0\u30EB\u30FC\u30D7 329" transform="translate(-43.86 -144.644)">
      <rect
        data-name="\u9577\u65B9\u5F62 784"
        width={145.783}
        height={300.88}
        rx={21.724}
        transform="translate(43.86 144.644)"
      />
      <path data-name="\u9577\u65B9\u5F62 785" fill="#fff" d="M50.141 184.298h131.78v74.423H50.141z" />
      <g data-name="\u30B0\u30EB\u30FC\u30D7 328">
        <path
          data-name="\u30D1\u30B9 1036"
          d="M181.894 198.3v-32.013a14.3 14.3 0 00-14.282-14.309h-14.1v1.922a7.579 7.579 0 01-7.572 7.586H86.931a7.579 7.579 0 01-7.572-7.586v-1.918H64.424a14.3 14.3 0 00-14.283 14.309V198.3z"
          fill="#2dacbd"
        />
      </g>
      <path
        data-name="\u30D1\u30B9 1037"
        d="M50.141 256.872v167.012a14.308 14.308 0 0014.309 14.308h103.1a14.308 14.308 0 0014.309-14.308V256.872z"
        fill="#fff"
      />
      <rect
        data-name="\u9577\u65B9\u5F62 786"
        width={34.733}
        height={3.524}
        rx={1.762}
        transform="translate(97.566 430.669)"
      />
      <path data-name="\u7DDA 6" fill="none" stroke="#f5f5f5" strokeMiterlimit={10} d="M50.267 259.622h131.364" />
      <path data-name="\u7DDA 7" fill="none" stroke="#f5f5f5" strokeMiterlimit={10} d="M50.267 198.818h131.364" />
      <circle
        data-name="\u6955\u5186\u5F62 472"
        cx={5.232}
        cy={5.232}
        r={5.232}
        transform="translate(145.289 181.982)"
        fill="#e7e7e7"
      />
      <circle
        data-name="\u6955\u5186\u5F62 473"
        cx={5.232}
        cy={5.232}
        r={5.232}
        transform="translate(160.571 181.982)"
        fill="#e7e7e7"
      />
      <circle
        data-name="\u6955\u5186\u5F62 474"
        cx={5.232}
        cy={5.232}
        r={5.232}
        transform="translate(145.289 166.296)"
        fill="#e7e7e7"
      />
      <circle
        data-name="\u6955\u5186\u5F62 475"
        cx={5.232}
        cy={5.232}
        r={5.232}
        transform="translate(160.571 166.296)"
        fill="#e7e7e7"
      />
      <circle
        data-name="\u6955\u5186\u5F62 476"
        cx={5.232}
        cy={5.232}
        r={5.232}
        transform="translate(56.93 166.296)"
        fill="#e7e7e7"
      />
      <circle
        data-name="\u6955\u5186\u5F62 477"
        cx={5.232}
        cy={5.232}
        r={5.232}
        transform="translate(72.212 166.296)"
        fill="#e7e7e7"
      />
      <circle
        data-name="\u6955\u5186\u5F62 478"
        cx={2.616}
        cy={2.616}
        r={2.616}
        transform="translate(108.752 227.373)"
        fill="#ffec03"
      />
      <circle
        data-name="\u6955\u5186\u5F62 479"
        cx={2.616}
        cy={2.616}
        r={2.616}
        transform="translate(115.433 227.373)"
        fill="#ffec03"
      />
      <circle
        data-name="\u6955\u5186\u5F62 480"
        cx={2.616}
        cy={2.616}
        r={2.616}
        transform="translate(122.115 227.373)"
        fill="#ffec03"
      />
      <circle
        data-name="\u6955\u5186\u5F62 481"
        cx={2.616}
        cy={2.616}
        r={2.616}
        transform="translate(128.796 227.373)"
        fill="#ffec03"
      />
      <circle
        data-name="\u6955\u5186\u5F62 482"
        cx={2.616}
        cy={2.616}
        r={2.616}
        transform="translate(135.478 227.373)"
        fill="#ccc"
      />
      <path data-name="\u9577\u65B9\u5F62 787" fill="#fc3" d="M55.464 267.304H176.81v67.253H55.464z" />
      <rect
        data-name="\u9577\u65B9\u5F62 788"
        width={79.441}
        height={11.975}
        rx={4.821}
        transform="translate(57.606 180.906)"
        fill="#e7e7e7"
      />
      <path data-name="\u9577\u65B9\u5F62 789" fill="#e5e5e5" d="M56.837 209.956h41.506v41.506H56.837z" />
      <path data-name="\u9577\u65B9\u5F62 790" fill="#eee" d="M108.328 210.194h66.045v3.938h-66.045z" />
      <path data-name="\u9577\u65B9\u5F62 791" fill="#eee" d="M108.328 216.892h42.422v3.938h-42.422z" />
      <path data-name="\u7DDA 8" fill="none" stroke="#f5f5f5" strokeMiterlimit={10} d="M50.267 393.427h131.364" />
      <circle
        data-name="\u6955\u5186\u5F62 483"
        cx={2.616}
        cy={2.616}
        r={2.616}
        transform="translate(108.752 361.178)"
        fill="#ffec03"
      />
      <circle
        data-name="\u6955\u5186\u5F62 484"
        cx={2.616}
        cy={2.616}
        r={2.616}
        transform="translate(115.433 361.178)"
        fill="#ffec03"
      />
      <circle
        data-name="\u6955\u5186\u5F62 485"
        cx={2.616}
        cy={2.616}
        r={2.616}
        transform="translate(122.115 361.178)"
        fill="#ffec03"
      />
      <circle
        data-name="\u6955\u5186\u5F62 486"
        cx={2.616}
        cy={2.616}
        r={2.616}
        transform="translate(128.796 361.178)"
        fill="#ffec03"
      />
      <circle
        data-name="\u6955\u5186\u5F62 487"
        cx={2.616}
        cy={2.616}
        r={2.616}
        transform="translate(135.478 361.178)"
        fill="#ccc"
      />
      <path data-name="\u9577\u65B9\u5F62 792" fill="#e5e5e5" d="M56.837 343.761h41.506v41.506H56.837z" />
      <path data-name="\u9577\u65B9\u5F62 793" fill="#eee" d="M108.328 343.999h66.045v3.938h-66.045z" />
      <path data-name="\u9577\u65B9\u5F62 794" fill="#eee" d="M108.328 350.696h42.422v3.938h-42.422z" />
      <circle
        data-name="\u6955\u5186\u5F62 488"
        cx={2.616}
        cy={2.616}
        r={2.616}
        transform="translate(108.752 417.548)"
        fill="#ffec03"
      />
      <circle
        data-name="\u6955\u5186\u5F62 489"
        cx={2.616}
        cy={2.616}
        r={2.616}
        transform="translate(115.433 417.548)"
        fill="#ffec03"
      />
      <circle
        data-name="\u6955\u5186\u5F62 490"
        cx={2.616}
        cy={2.616}
        r={2.616}
        transform="translate(122.115 417.548)"
        fill="#ffec03"
      />
      <circle
        data-name="\u6955\u5186\u5F62 491"
        cx={2.616}
        cy={2.616}
        r={2.616}
        transform="translate(128.796 417.548)"
        fill="#ffec03"
      />
      <circle
        data-name="\u6955\u5186\u5F62 492"
        cx={2.616}
        cy={2.616}
        r={2.616}
        transform="translate(135.478 417.548)"
        fill="#ccc"
      />
      <path data-name="\u9577\u65B9\u5F62 795" fill="#e5e5e5" d="M56.837 400.13h41.506v22.808H56.837z" />
      <path data-name="\u9577\u65B9\u5F62 796" fill="#eee" d="M108.328 400.368h66.045v3.938h-66.045z" />
      <path data-name="\u9577\u65B9\u5F62 797" fill="#eee" d="M108.328 407.066h42.422v3.938h-42.422z" />
    </g>
  </Root>
);

const Root = styled('svg')();

export default AmazonDevice169;
